module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle2"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PREFACE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Acknowledgement"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_FM01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ON LANGUAGE AND PRONUNCIATION")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_FM02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("DRAMATIS PERSONAE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_FM03"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("MAPS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("1")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INDING THE")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IELD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ch1_1"
    }
  }, [_vm._v("Road Warriors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ch1_2"
    }
  }, [_vm._v("Kyzyl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter01#ch1_3"
    }
  }, [_vm._v("Reinventing Tuva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("2")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD IS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIVE WITH THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USIC OF SOUND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ch2_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Musical Offerings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ch2_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In a Cave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter02#ch2_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Natural Reverb")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_FM05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTERLUDE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("3")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISTENING THE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UVAN")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03#ch3_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timbre-Centered Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter03#ch3_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Throat-Singing: The Ideal Timbral Art")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("4")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUND")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IMESIS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mimesis and the Power of Representation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hunters: The Earliest Sound Technologists?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ludic Mimesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sound Mimesis and Spiritual Landscape")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sound Mimesis as Narrative")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Mimesis of Mimesis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter04#ch4_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mimesis as Cultural Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("5")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USIC")]), _vm._v(", S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OUND, AND")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05#ch5_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animal Spirits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05#ch5_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Signaling and Singing to Animals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05#ch5_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Listening to Animals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05#ch5_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Animals in Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter05#ch5_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“Animal-Style” Art and Music")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "big1"
  }, [_vm._v("6")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIMIST")]), _vm._v(" V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IEW OF THE")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Huun-Huur-Tu at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epic Dreams")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shamans and Champagne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spirit of Manas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Women Are Not Supposed to Do This")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Ondar Phenomenon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter06#ch6_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crete")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSTLUDE")]), _vm._v(": A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROPRIATION AND")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TS")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GLOSSARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("NOTES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BIBLIOGRAPHY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bm02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACCESSING AUDIO FILES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Bm03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("ACCESSING VIDEO FILES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47063ba0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Contents.vue
// module id = 69
// module chunks = 0